import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ThemeProvider } from 'styled-components';
import ContextProvider from './context/Context';
import Router from './router';
import Toast from './components/common/toast';
import theme from './config/theme.json';
import { Container, Logo } from './main.styled';
import logo from './assets/images/Enel_Logo_Primary_RGB.svg';

const queryClient = new QueryClient();
const Structure = () => (

  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <ContextProvider>
        <Container>
          <Logo>
            <img src={logo} alt="Enel X Logo" />
          </Logo>
          <Router />
          <Toast />
        </Container>
      </ContextProvider>
      <ReactQueryDevtools initialIsOpen />
    </ThemeProvider>
  </QueryClientProvider>

);

export default Structure;
